// 평면 카테고리 목록 → 3단계 트리 구성.
import type { Category } from '@shared/types';

export const MAX_CATEGORY_DEPTH = 3;

export interface CategoryNode extends Category {
  depth: number; // 1~3
  children: CategoryNode[];
}

export function buildCategoryTree(cats: Category[]): CategoryNode[] {
  const byId = new Map<number, CategoryNode>();
  for (const c of cats) byId.set(c.id, { ...c, depth: 1, children: [] });

  const roots: CategoryNode[] = [];
  for (const node of byId.values()) {
    const parent = node.parentId != null ? byId.get(node.parentId) : undefined;
    if (parent) parent.children.push(node);
    else roots.push(node);
  }

  const assign = (nodes: CategoryNode[], depth: number) => {
    nodes.sort((a, b) => a.sortOrder - b.sortOrder);
    for (const n of nodes) {
      n.depth = depth;
      assign(n.children, depth + 1);
    }
  };
  assign(roots, 1);
  return roots;
}

/** 트리를 표시 순서(부모→자식)대로 평탄화. depth 포함. */
export function flattenCategoryTree(cats: Category[]): CategoryNode[] {
  const out: CategoryNode[] = [];
  const walk = (nodes: CategoryNode[]) => {
    for (const n of nodes) {
      out.push(n);
      walk(n.children);
    }
  };
  walk(buildCategoryTree(cats));
  return out;
}

/** select 옵션용 계층 라벨. 단계별 접두 기호로 표시(옵션 leading 공백 collapse 회피). */
export function categoryOptionLabel(node: CategoryNode): string {
  if (node.depth <= 1) return node.name;
  return '└' + '─'.repeat(node.depth - 2) + ' ' + node.name;
}
